module.exports = __webpack_public_path__ + "img/login_bg_1x.c571ead5.png";